import { V6Client } from '@aws-amplify/api-graphql';
import { InfoModalProps, InputModalProps } from '@gmg/gmg-react-components';
import { generateClient } from 'aws-amplify/api';
import React from 'react';
import { FeatureFlags } from './Config';
import { Role as APIRole } from './graphql/generated/types';
import { TrackingEvent } from './tracking';
import { ProductLine } from './viewModels/Products';

export type Role = `${APIRole}`;
export interface CurrentUser {
    firstName?: string;
    lastName?: string;
    userId: string;
    email: string;
    role: Role | undefined;
    // Users with an orgId are allowed to access organization related pages.
    orgId: string | undefined;
    orgName?: string;
    // Users with an orgIdFromInvitation are invited users who still need to accept the invitation. They are redirected to the Join page.
    orgIdFromInvitation?: string;
    orgNameFromInvitation?: string;
    modules: Array<ProductLine>;
};
//export const LanguageArray = ['en', 'de', 'ko', 'zh-Hant', 'zh', 'ja', 'es', 'pt', 'it', 'fr'] as const;
export const LanguageArray = ['en', 'de'] as const;
export type Language = typeof LanguageArray[number]; // is the same as type Language = 'en' | 'de' |, see https://vieirinha.dev/blog/2020/12/27/typescript-iterate-over-string-literal.html

export interface IAppContext {
    api: V6Client<never>;
    onError: (e: Error) => void;
    user: CurrentUser | undefined; // note that is currently not really needed in context, but there might be upcoming features which make it necessary. if not, remove it
    onShowModal: (variant: 'infoModal' | 'inputModal', options: InfoModalProps | InputModalProps) => void;
    language: Language;
    featureFlags: FeatureFlags;
    partnerPortalBaseUrl: string;
    partnerPortalIdentityProviderName: string;
    partnerPortalUserPoolWebClientId?: string;
    trackEvent: (event: TrackingEvent) => void;
}

const api = generateClient();

export const defaultContext: IAppContext = {
    api,
    onError: () => { },
    user: undefined,
    onShowModal: () => { },
    language: 'en',
    featureFlags: {
        showPartnerPortal: false,
        showDataAndAccessManagement: false,
        showSiteAssignment: false,
        showSitesPage: false,
        hideOptimize: true,
        hideColorCardUsage: true,
    },
    partnerPortalBaseUrl: '',
    partnerPortalIdentityProviderName: '',
    partnerPortalUserPoolWebClientId: undefined,
    trackEvent: () => { },
};

const AppContext = React.createContext<IAppContext>(defaultContext);

export default AppContext;
